<div class="hw-content">
  <div class="row">
    <div class="col-12">
      <div class="sub-menu-landing">
        <div class="row sub-heading">
          {{ activeMenuItem.helpTextLBL | fnTranslate }}
        </div>
        <div class="row">
          @for (item of activeMenuItem.menuItemArray; track item) {
          <div class="col-3" [ngClass]="{ hide: item.isDisabled }" (click)="menuClickHandler(item)">
            <div class="sml-img-data-wrap">
              <div class="sml-img-wrap">
                @if (item && item.menuSmallIcon){
                <i [classList]="item.menuSmallIcon"></i>
                } @else if (item && item.smallIcon) {
                <i [classList]="item.smallIcon"></i>
                }
              </div>
              <div class="sml-Data">
                <h5 class="choppOff">
                  <span innerHTML="{{ item.name | fnTranslate }}"></span>
                </h5>
                <p class="choppOff" [title]="item.helpTextLBL | fnTranslate">
                  <span innerHTML="{{ item.helpTextLBL | fnTranslate }}"></span>
                </p>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
